import React from "react";

const t = {
  en: { metro: "Metro", bmtc: "BMTC", coming: "Coming Soon" },
  hi: { metro: "मेट्रो", bmtc: "बीएमटीसी", coming: "जल्द आ रहा है" },
  kn: { metro: "ಮೆಟ್ರೊ", bmtc: "ಬಿಎಂಟಿಸಿ", coming: "ಶೀಘ್ರದಲ್ಲೇ" }
};

export default function TransportToggle({
  theme = "light",
  language = "en",
  active = "metro",
  onSelect
}) {
  const labels = t[language];

  const container = {
    position: "absolute",
    top: "70px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: "6px",
    width: "80%",
    maxWidth: "280px",
    zIndex: 10
  };

  const base = {
    flex: 1,
    height: "38px",
    minWidth: "60px",
    fontSize: "0.85rem",
    fontWeight: 600,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    cursor: "pointer"
  };

  const metroStyle = {
    ...base,
    background: active === "metro"
      ? theme === "dark" ? "#FFD028" : "#005bb5"
      : theme === "dark" ? "#333" : "#e5e7eb",
    color: active === "metro"
      ? theme === "dark" ? "#111" : "#fff"
      : theme === "dark" ? "#eee" : "#444",
  };

  const bmtcStyle = {
    ...base,
    background: theme === "dark" ? "#333" : "#ffffffff",
    color: theme === "dark" ? "#eee" : "#444",
    opacity: 1,
    pointerEvents: "none",
    position: "relative"
  };

  const tag = {
    position: "absolute",
    top: "-6px",
    right: "-6px",
    background: "#e11d48",
    color: "#fff",
    fontSize: "0.55rem",
    padding: "2px 5px",
    borderRadius: "6px"
  };

  return (
    <div style={container}>
      <div style={metroStyle} onClick={() => onSelect?.("metro")}>
        {labels.metro}
      </div>

      <div style={bmtcStyle}>
        {labels.bmtc}
        <span style={tag}>{labels.coming}</span>
      </div>
    </div>
  );
}
